import * as React from "react";

const tableStyles = {
  wrapper: {
    width: '100%',
    overflow: 'auto',
    borderRadius: '12px',
    border: '1px solid #e2e8f0',
    backgroundColor: 'white',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '0.875rem',
  },
  header: {
    backgroundColor: '#f8fafc',
    borderBottom: '1px solid #e2e8f0',
  },
  headerRow: {
    borderBottom: '1px solid #e2e8f0',
  },
  headerCell: {
    padding: '0.75rem 1rem',
    textAlign: 'left',
    fontWeight: 600,
    color: '#374151',
    whiteSpace: 'nowrap',
  },
  body: {},
  row: {
    borderBottom: '1px solid #f1f5f9',
    transition: 'background-color 0.15s ease',
  },
  rowHover: {
    backgroundColor: '#fafafa',
  },
  cell: {
    padding: '0.75rem 1rem',
    verticalAlign: 'middle',
    color: '#1f2937',
  },
  emptyRow: {
    textAlign: 'center',
    padding: '2rem',
    color: '#9ca3af',
  },
};

const Table = React.forwardRef(({ style, ...props }, ref) => (
  <div style={tableStyles.wrapper}>
    <table ref={ref} style={{ ...tableStyles.table, ...style }} {...props} />
  </div>
));
Table.displayName = "Table";

const TableHeader = React.forwardRef(({ style, ...props }, ref) => (
  <thead ref={ref} style={{ ...tableStyles.header, ...style }} {...props} />
));
TableHeader.displayName = "TableHeader";

const TableBody = React.forwardRef(({ style, ...props }, ref) => (
  <tbody ref={ref} style={{ ...tableStyles.body, ...style }} {...props} />
));
TableBody.displayName = "TableBody";

const TableRow = React.forwardRef(({ style, ...props }, ref) => {
  const [isHovered, setIsHovered] = React.useState(false);
  return (
    <tr
      ref={ref}
      style={{
        ...tableStyles.row,
        ...(isHovered ? tableStyles.rowHover : {}),
        ...style,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    />
  );
});
TableRow.displayName = "TableRow";

const TableHead = React.forwardRef(({ style, ...props }, ref) => (
  <th ref={ref} style={{ ...tableStyles.headerCell, ...style }} {...props} />
));
TableHead.displayName = "TableHead";

const TableCell = React.forwardRef(({ style, ...props }, ref) => (
  <td ref={ref} style={{ ...tableStyles.cell, ...style }} {...props} />
));
TableCell.displayName = "TableCell";

export {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
};
